import { alpha } from '@mui/system'
import globalTheme from '../global'

const IconButton = {
	MuiIconButton: {
		styleOverrides: {
			root: {
				padding: '22px',
				'&.Mui-disabled': {
					// backgroundColor: alpha(globalTheme.palette.primary.main, '0.1'),
					backgroundColor: 'unset',
					color: globalTheme.palette.grey.medium,
				},
				'&.iconClose': {
					position: 'absolute',
					padding: 10,
					zIndex: 2,
				},
			},
			colorPrimary: {
				backgroundColor: globalTheme.palette.primary.main,
				color: globalTheme.palette.primary.contrastText,
				'&:hover': {
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.85'),
				},
				'&:focus': {
					backgroundColor: globalTheme.palette.primary.main,
				},
				'&:active': {
					backgroundColor: alpha(globalTheme.palette.primary.main, '0.7'),
				},
				'&.Mui-disabled': {
					// backgroundColor: alpha(globalTheme.palette.primary.main, '0.1'),
					color: globalTheme.palette.grey.medium,
				},
				'& .MuiCircularProgress-root': {
					color: globalTheme.palette.primary.contrastText,
				},
				'& .MuiSvgIcon-root': {
					color: 'inherit',
				},
			},
			colorSecondary: {
				backgroundColor: globalTheme.palette.secondary.main,
				color: globalTheme.palette.secondary.contrastText,
				'&:hover': {
					backgroundColor: alpha(globalTheme.palette.secondary.main, '0.85'),
				},
				'&:focus': {
					backgroundColor: globalTheme.palette.secondary.main,
				},
				'&:active': {
					backgroundColor: globalTheme.palette.secondary.dark,
				},
				'&.Mui-disabled': {
					color: globalTheme.palette.secondary.contrastText,
					// backgroundColor: alpha(globalTheme.palette.secondary.main, '0.2'),
				},
				'& .MuiCircularProgress-root': {
					color: globalTheme.palette.secondary.contrastText,
				},
				'& .MuiSvgIcon-root': {
					color: globalTheme.palette.secondary.contrastText,
				},
			},
		},
	},
}

export default IconButton
